import {
    HttpResponse,
    UserTaskActivityModel,
    QueryModel,
    RequestParams,
    UserTaskActivityModelIEnumerableApiResultSuccess,
    UserTaskActivityModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    FullRequestParams,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse, CrudPartialUpdatePatch} from '@/libs/core/crud/crud-service';

export class UserTaskActivitysDataService implements CrudService<UserTaskActivityModel, UserTaskActivityModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<UserTaskActivityModel>): Promise<CrudListResponse<UserTaskActivityModel>> {
        return ApiService.api.getUserTaskActivityBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<UserTaskActivityModel>> {
        return ApiService.api.getUserTaskActivityById(id, params);
    }

    create(item: UserTaskActivityModel, params?: RequestParams): Promise<CrudResponse<UserTaskActivityModel>> {
        return ApiService.api.insertUserTaskActivity(item, params);
    }

    update(item: UserTaskActivityModel, params?: RequestParams): Promise<UserTaskActivityModel> {
        return ApiService.api.updateUserTaskActivity(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<UserTaskActivityModel> {
        return ApiService.api.patchUserTaskActivity(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<UserTaskActivityModel>): Promise<CrudListResponse<UserTaskActivityModel>> {
        return ApiService.api.deleteUserTaskActivities(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<UserTaskActivityModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
